<template>
  <page :title="$tc('magazines.feeds')">
<!--    <div slot="page-header-right">-->
<!--      <button @click="draft" class="button is-primary">Add Feed</button>-->
<!--    </div>-->

    <div class="box">

      <filters @input=" ( search ) => feeds.filter(search, true).load()"></filters>

      <hr />

      <b-table
        class="is-middle"
        :data="feeds.data"
        :loading="feeds.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :total="feeds.total"
        :per-page="feeds.per_page"
        @page-change="
          page => {
            feeds.changePage(page);
          }
        "
        backend-sorting
        @sort="(field, direction) => feeds.sort(field, direction)"
        :default-sort="['id', 'desc']"
      >
        <template slot-scope="props">
          <b-table-column label="#" field="id" width="100" sortable>
            <router-link :to="`/feeds/${props.row.id}/edit`">{{
              props.row.id
            }}</router-link>
          </b-table-column>

          <b-table-column :label="$tc('background')" width="100">
            <b-dropdown>
              <a slot="trigger">
                <img style="height: 30px"
                  :src="props.row.background"
                />
              </a>

              <div class="dropdown-item">
                <img :src="props.row.background"/>
              </div>

            </b-dropdown>
          </b-table-column>

          <b-table-column :label="$tc('support_ticket.title')" field="title">
            <span class="tag">{{ props.row.locale }}</span>
            <div class="has-text-grey mb-1">{{ props.row.title }}</div>
          </b-table-column>

          <b-table-column field="title" :label="$tc('detail')" sortable>
            <router-link v-if="props.row.issue"
              :to="`/magazine/magazines/${props.row.issue.magazine_id}/edit`"
              class="has-text-grey mr-2"
            >{{ props.row.issue.magazine.name }}  / </router-link
            >

            <router-link v-if="props.row.issue"
              :to="`/magazine/magazine/issues/${props.row.issue.id}/edit`"
              class="has-text-dark"
              size="is-large"
            >{{ props.row.issue.title }} /</router-link
            >

            <router-link v-if="props.row.issue"
              :to="`/magazine/magazine/issues/${props.row.issue.id}`"
              class="has-text-black"
              size="is-large"
            > {{ props.row.page }} </router-link
            >
          </b-table-column>

          <b-table-column custom-key="order">
            <span v-if="props.row.pin" class="tag is-primary is-small">{{
              props.row.pin.order
            }}</span>
          </b-table-column>

          <b-table-column :label="$tc('support_ticket.status._name')" field="status" centered>
            <span v-if="props.row.published_at" class="tag is-success"
              >{{$tc('support_ticket.status.published')}}</span
            >

            <span v-else class="tag">{{$tc('support_ticket.status.unpublished')}}</span>
          </b-table-column>

          <b-table-column :label="$tc('dater.published')" field="published_at" sortable>
            <div class="has-text-grey">{{ props.row.published_at }}</div>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>No results have found.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>

import Filters from "./Filters";

export default {
  components: {
    Filters,
  },

  data() {
    return {
      feeds: new window.PaginatedRemoteCollection("/admin/api/feeds")
    };
  },

  created() {
    this.feeds.filter({ search: localStorage.getItem('feed-search') || '' }).load();
  },

  methods: {
    draft() {
      new window.Form({'background_ratio': 1, 'description': 'none'}).post("/admin/api/feeds").then(({ data: feed }) => {
        this.$router.push(`/feeds/${feed.id}/edit`);
      });
    }
  }
};
</script>
